import { render, staticRenderFns } from "./CareerOrientation.vue?vue&type=template&id=686324f3"
import script from "./CareerOrientation.vue?vue&type=script&lang=js"
export * from "./CareerOrientation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports